import { createFileRoute, notFound } from '@tanstack/react-router'
import { CategoryPageViewModel } from '@/components/catalog/category-page/category-page.view-model'
import { NotFoundFloraViewModel } from '@/components/shared/not-found-flora/not-found-flora.view-model'
import { CATEGORY_LABELS, CATEGORY_STORIES } from '@/constants/products'
import { SITE_BASE_URL } from '@/constants/site'
import { buildPageMeta } from '@/lib/seo/build-page-meta'
import { productCategorySchema } from '@/schemas/product.schema'
import { productsQueryOptions } from '@/services/products/use-products'

const CATALOG_META_SUFFIX =
  'Entrega em toda a cidade, com buquês montados à mão no ateliê.'

export const Route = createFileRoute('/_editorial/catalogo/$categoria')({
  loader: ({ context, params }) => {
    const parsedCategory = productCategorySchema.safeParse(params.categoria)
    if (!parsedCategory.success) {
      throw notFound()
    }
    return context.queryClient.ensureQueryData(
      productsQueryOptions.byCategory(parsedCategory.data),
    )
  },
  head: ({ params }) => {
    const parsedCategory = productCategorySchema.safeParse(params.categoria)
    if (!parsedCategory.success) {
      return {}
    }

    const category = parsedCategory.data
    const label = CATEGORY_LABELS[category]

    return {
      ...buildPageMeta({
        title: `${label} — Flora Ateliê`,
        description: `${CATEGORY_STORIES[category]} ${CATALOG_META_SUFFIX}`,
        path: `/catalogo/${category}`,
      }),
      scripts: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Início',
                item: SITE_BASE_URL,
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Catálogo',
                item: `${SITE_BASE_URL}/catalogo`,
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: label,
                item: `${SITE_BASE_URL}/catalogo/${category}`,
              },
            ],
          }),
        },
      ],
    }
  },
  notFoundComponent: NotFoundFloraViewModel,
  component: CategoriaRouteComponent,
})

function CategoriaRouteComponent() {
  const { categoria } = Route.useParams()
  const category = productCategorySchema.parse(categoria)
  return <CategoryPageViewModel category={category} />
}
